/**
 * Formats the given number to be readable Ft currency
 */
export function formatPrice(price: number, unit?: string | null): string {
  return (
    price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") +
    " Ft" +
    (unit ? " / " + unit : "")
  );
}
